<div class="header-gradient"></div>
<div class="header divider">
  <div class="container">
    <div class="row">
      <div class="col-md-3 col-lg-2 logo-section">
        <img
          class="logo"
          src="../../../../assets/images/Logo.png"
          width="auto" height="auto"
          alt="Alight Care Portal"
        />
      </div>
    </div>
  </div>
</div>

<app-alerts
  [isWarningToHide]="rootScope.isWarningToHide"
  [isErrorToHide]="rootScope.isErrorToHide"
  [isInfoToHide]="rootScope.isInfoToHide"
  [isSuccessToHide]="rootScope.isSuccessToHide"
  [msg]="rootScope.alertMsg"
>
</app-alerts>

<div class="container">
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="offset-md-3 col-md-6 offset-lg-2 col-lg-8 logout-container" *ngIf="!rootScope.sessionExpiry">
          <h1 class="logout-heading">You’re logged out</h1>
          <p class="logout-text">
            To log in again, click the button below. Otherwise, you can close
            the window.
          </p>
          <f-button
            (click)="logInAgain()"
            text="Log in again"
            title="Log in again"
            type="button"
            variant="progressive"
          ></f-button>
        </div>

        <div class="offset-md-3 col-md-6 offset-lg-2 col-lg-8 logout-container" *ngIf="rootScope.sessionExpiry">
          <h1 class="logout-heading">This session has ended</h1>
          <p class="logout-text">
            Only one active session is permitted at a time. Please close this window.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
